function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { Button, Classes, Icon } from "@blueprintjs/core";
import classNames from "classnames";
import "./style.css";

var CollapsibleCard = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CollapsibleCard, _Component);

  function CollapsibleCard(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: true
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCardInfo", function () {
      if (_this.props.toggle) _this.props.toggle();else {
        _this.setState({
          open: !_this.state.open
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getIsOpen", function () {
      if (_this.props.isOpen !== undefined) {
        return _this.props.isOpen;
      } else {
        return _this.state.open;
      }
    });

    _this.state = {
      open: !props.initialClosed
    };
    return _this;
  }

  var _proto = CollapsibleCard.prototype;

  _proto.renderOpenCard = function renderOpenCard() {
    return this.props.children;
  };

  _proto.render = function render() {
    var open = this.getIsOpen();
    var _this$props = this.props,
        title = _this$props.title,
        icon = _this$props.icon,
        openTitleElements = _this$props.openTitleElements,
        _this$props$noCard = _this$props.noCard,
        noCard = _this$props$noCard === void 0 ? false : _this$props$noCard,
        className = _this$props.className,
        style = _this$props.style; // blueprintjs card will match our table color. which looks really bad when a table is in a card.

    return /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "tg-card": !noCard,
        open: open
      }, className),
      style: _extends({
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 15,
        paddingRight: 15
      }, style)
    }, /*#__PURE__*/React.createElement("div", {
      className: "tg-card-header",
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "tg-card-header-title"
    }, icon && /*#__PURE__*/React.createElement(Icon, {
      icon: icon
    }), /*#__PURE__*/React.createElement("h6", {
      style: {
        marginBottom: 0,
        marginRight: 10,
        marginLeft: 10
      }
    }, title), /*#__PURE__*/React.createElement("div", null, open && openTitleElements)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      icon: open ? "minimize" : "maximize",
      className: classNames(Classes.MINIMAL, "info-btn", "tg-collapse-toggle"),
      onClick: this.toggleCardInfo
    }))), open && this.renderOpenCard());
  };

  return CollapsibleCard;
}(Component);

export { CollapsibleCard as default };